exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn_structure[data-v-8b1156d6]{width:auto;min-width:10rem;max-width:14.5rem;height:auto;min-height:3.2rem;max-height:3.8rem;padding:.2rem .4rem;border-radius:6px;border:0;color:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;font-family:Muli;font-size:1.2rem;font-weight:600}.btn_structure.red[data-v-8b1156d6]{background-color:#ef4411}.btn_structure.blue[data-v-8b1156d6]{background-color:#0080fc}.btn_structure.grey[data-v-8b1156d6]{background-color:#c4c4c4}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8b1156d6","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/dashboard-v5/delete-account/components/btn-delete.vue
// module id = 1kO9
// module chunks = 0